import React from 'react';
import { HorizontalFlex } from 'smartsuite-ui';
import PropTypes from 'prop-types';
import { getFormattedValue } from '../../../dashboardUtils';

function shouldShowTooltip(activeIndex, payload) {
    return activeIndex !== -1 && payload.length;
}

// eslint-disable-next-line complexity
export default function PieChartTooltip({
    activeIndex,
    axisFormatter,
    axisKey,
    dataFormat,
    dataFormatter,
    payload,
    suffix,
}) {
    if (!shouldShowTooltip(activeIndex, payload)) {
        return null;
    }

    const allProperties = {
        ...payload[0],
        ...payload[0].payload,
    };

    const label = axisFormatter(allProperties[axisKey]);
    const dataValue = getFormattedValue(
        allProperties.value,
        suffix,
        dataFormatter,
        dataFormat
    );

    return (
        <div key={label} className="custom-tooltip">
            <HorizontalFlex>
                <span
                    style={{ backgroundColor: allProperties.fill }}
                    className="custom-tooltip__color-indicator"
                />
                <span>
                    {label}: {dataValue}
                </span>
            </HorizontalFlex>
        </div>
    );
}

PieChartTooltip.propTypes = {
    activeIndex: PropTypes.number.isRequired,
    axisFormatter: PropTypes.func,
    axisKey: PropTypes.string,
    dataFormat: PropTypes.string,
    dataFormatter: PropTypes.func,
    payload: PropTypes.instanceOf(Array),
    suffix: PropTypes.string,
};

PieChartTooltip.defaultProps = {
    axisKey: null,
    dataFormat: null,
    dataFormatter: null,
    axisFormatter: (value) => value,
    payload: [],
    suffix: '',
};
